import ko from "knockout";
import moduleLoader from "flow/wrappers/moduleLoader";
import manifestManager from "flow/utils/manifestManager";
import MyFlow from "flow/MyFlow";

class LicenseEntry {
    name: string;
    license: string;
    licenseText: string;
    repository: string;
    homePage: string;
    author: string;
    expanded: KnockoutObservable<boolean>;
    toggleExpanded: () => void;

    constructor(data: any) {
        this.name = data.name;
        this.license = data.license;
        this.licenseText = data.licenseText;
        this.repository = data.repository !== "Unknown" ? data.repository : undefined;
        this.homePage = data.homePage !== "Unknown" ? data.homePage : undefined;
        this.author = data.author;
        this.expanded = ko.observable(false);
        this.toggleExpanded = () => {
            this.expanded(!this.expanded());
        };
    }
}

type LicenseBundle = {
    path: string;
};

export default class LicenseContainer {
    licenses = ko.observableArray().extend({
        sortable: {
            key: "name"
        }
    });

    constructor(private readonly myFlow: MyFlow) {}

    activate = () => {
        const licenseBundlePaths: string[] = manifestManager.getAllLicenseBundles().map((lb: LicenseBundle) => lb.path);

        const promises: Promise<void>[] = [];
        const bundles: any[] = [];

        licenseBundlePaths.forEach(licenseBundlePath => {
            promises.push(
                new Promise(resolve => {
                    moduleLoader
                        .requireSingleAsync("text!" + licenseBundlePath)
                        .then((result: string) => {
                            bundles.push(result);
                            resolve();
                        })
                        .catch(() => {
                            this.myFlow.warn("Could not read license bundle " + licenseBundlePath);
                            resolve();
                        });
                })
            );
        });

        const licenseStore: { [id: string]: LicenseEntry } = {};

        Promise.all(promises)
            .then(() => {
                bundles.forEach(bundle => {
                    try {
                        const licenseData = JSON.parse(bundle);
                        const entries: LicenseEntry[] = licenseData.map((l: any) => {
                            return new LicenseEntry(l);
                        });
                        entries.forEach(entry => {
                            if (!licenseStore[entry.name]) {
                                licenseStore[entry.name] = entry;
                            } else {
                                // Replace if new has license text and old is missing
                                if (!licenseStore[entry.name].licenseText && entry.licenseText) {
                                    licenseStore[entry.name] = entry;
                                } else {
                                    // Keep old/first
                                    this.myFlow.debug("Ignored additional instance of license " + entry.name);
                                }
                            }
                        });
                    } catch (e) {
                        this.myFlow.warn("Failed to parse license bundle");
                        this.myFlow.logObjects(e);
                    }
                });
            })
            .then(() => {
                this.licenses(Object.values(licenseStore));
            });
    };
}
